import React from 'react';
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import { useCallback } from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Button, CardActionArea, CardActions, Alert } from '@mui/material';
import certification1 from "../images/certificationcardone.jpg";
import './pagesStyles.css';
import Divider from '@mui/material/Divider';

const Certifications = () => {
	
		const options = {
			autoPlay: true,
			background: {
			  color: {
				value: "#000"
			  },
			  image: "",
			  position: "",
			  repeat: "",
			  size: "",
			  opacity: 1
			},
			backgroundMask: {
			  composite: "destination-out",
			  cover: {
				color: {
				  value: "#fff"
				},
				opacity: 1
			  },
			  enable: false
			},
			defaultThemes: {},
			delay: 0,
			fullScreen: {
			  enable: true,
			  zIndex: -1
			},
			detectRetina: true,
			duration: 0,
			fpsLimit: 120,
			interactivity: {
			  detectsOn: "window",
			  events: {
				onClick: {
				  enable: false,
				  mode: []
				},
				onDiv: {
				  selectors: [],
				  enable: false,
				  mode: [],
				  type: "circle"
				},
				onHover: {
				  enable: true,
				  mode: "trail",
				  parallax: {
					enable: false,
					force: 2,
					smooth: 10
				  }
				},
				resize: {
				  delay: 0.5,
				  enable: true
				}
			  },
			  modes: {
				attract: {
				  distance: 200,
				  duration: 0.4,
				  easing: "ease-out-quad",
				  factor: 1,
				  maxSpeed: 50,
				  speed: 1
				},
				bounce: {
				  distance: 200
				},
				bubble: {
				  distance: 200,
				  duration: 0.4,
				  mix: false,
				  divs: {
					distance: 200,
					duration: 0.4,
					mix: false,
					selectors: []
				  }
				},
				connect: {
				  distance: 80,
				  links: {
					opacity: 0.5
				  },
				  radius: 60
				},
				grab: {
				  distance: 100,
				  links: {
					blink: false,
					consent: false,
					opacity: 1
				  }
				},
				push: {
				  default: true,
				  groups: [],
				  quantity: 4
				},
				remove: {
				  quantity: 2
				},
				repulse: {
				  distance: 200,
				  duration: 0.4,
				  factor: 100,
				  speed: 1,
				  maxSpeed: 50,
				  easing: "ease-out-quad",
				  divs: {
					distance: 200,
					duration: 0.4,
					factor: 100,
					speed: 1,
					maxSpeed: 50,
					easing: "ease-out-quad",
					selectors: []
				  }
				},
				slow: {
				  factor: 3,
				  radius: 200
				},
				trail: {
				  delay: 0.005,
				  pauseOnStop: true,
				  quantity: 5,
				  particles: {
					color: {
					  value: "#ff0000",
					  animation: {
						enable: true,
						speed: 400,
						sync: true
					  }
					},
					collisions: {
					  enable: false
					},
					links: {
					  enable: false
					},
					move: {
					  outModes: {
						default: "destroy"
					  },
					  speed: 2
					},
					size: {
					  value: 5,
					  animation: {
						enable: true,
						speed: 5,
						minimumValue: 1,
						sync: true,
						startValue: "min",
						destroy: "max"
					  }
					}
				  }
				},
				light: {
				  area: {
					gradient: {
					  start: {
						value: "#ffffff"
					  },
					  stop: {
						value: "#000000"
					  }
					},
					radius: 1000
				  },
				  shadow: {
					color: {
					  value: "#000000"
					},
					length: 2000
				  }
				}
			  }
			},
			manualParticles: [],
			particles: {
			  bounce: {
				horizontal: {
				  random: {
					enable: false,
					minimumValue: 0.1
				  },
				  value: 1
				},
				vertical: {
				  random: {
					enable: false,
					minimumValue: 0.1
				  },
				  value: 1
				}
			  },
			  collisions: {
				absorb: {
				  speed: 2
				},
				bounce: {
				  horizontal: {
					random: {
					  enable: false,
					  minimumValue: 0.1
					},
					value: 1
				  },
				  vertical: {
					random: {
					  enable: false,
					  minimumValue: 0.1
					},
					value: 1
				  }
				},
				enable: true,
				mode: "bounce",
				overlap: {
				  enable: true,
				  retries: 0
				}
			  },
			  color: {
				value: "#ff0000",
				animation: {
				  h: {
					count: 0,
					enable: true,
					offset: 0,
					speed: 50,
					decay: 0,
					sync: false
				  },
				  s: {
					count: 0,
					enable: false,
					offset: 0,
					speed: 1,
					decay: 0,
					sync: true
				  },
				  l: {
					count: 0,
					enable: false,
					offset: 0,
					speed: 1,
					decay: 0,
					sync: true
				  }
				}
			  },
			  groups: {
				z5000: {
				  number: {
					value: 70
				  },
				  zIndex: {
					value: 50
				  }
				},
				z7500: {
				  number: {
					value: 30
				  },
				  zIndex: {
					value: 75
				  }
				},
				z2500: {
				  number: {
					value: 50
				  },
				  zIndex: {
					value: 25
				  }
				},
				z1000: {
				  number: {
					value: 40
				  },
				  zIndex: {
					value: 10
				  }
				}
			  },
			  move: {
				angle: {
				  offset: 0,
				  value: 90
				},
				attract: {
				  distance: 200,
				  enable: false,
				  rotate: {
					x: 3000,
					y: 3000
				  }
				},
				center: {
				  x: 50,
				  y: 50,
				  mode: "percent",
				  radius: 0
				},
				decay: 0,
				distance: {},
				direction: "none",
				drift: 0,
				enable: true,
				gravity: {
				  acceleration: 9.81,
				  enable: false,
				  inverse: false,
				  maxSpeed: 50
				},
				path: {
				  clamp: true,
				  delay: {
					random: {
					  enable: false,
					  minimumValue: 0
					},
					value: 0
				  },
				  enable: false,
				  options: {}
				},
				outModes: {
				  default: "out",
				  bottom: "out",
				  left: "out",
				  right: "out",
				  top: "out"
				},
				random: false,
				size: false,
				speed: 2,
				spin: {
				  acceleration: 0,
				  enable: false
				},
				straight: false,
				trail: {
				  enable: false,
				  length: 10,
				  fillColor: {
					value: "#000000"
				  }
				},
				vibrate: false,
				warp: false
			  },
			  number: {
				density: {
				  enable: true,
				  width: 1920,
				  height: 1080
				},
				limit: 0,
				value: 100
			  },
			  opacity: {
				random: {
				  enable: true,
				  minimumValue: 0.3
				},
				value: {
				  min: 0.3,
				  max: 0.8
				},
				animation: {
				  count: 0,
				  enable: true,
				  speed: 0.5,
				  decay: 0,
				  sync: false,
				  destroy: "none",
				  startValue: "random",
				  minimumValue: 0.3
				}
			  },
			  reduceDuplicates: false,
			  shadow: {
				blur: 0,
				color: {
				  value: "#000"
				},
				enable: false,
				offset: {
				  x: 0,
				  y: 0
				}
			  },
			  shape: {
				options: {},
				type: "circle"
			  },
			  size: {
				random: {
				  enable: true,
				  minimumValue: 1
				},
				value: {
				  min: 1,
				  max: 3
				},
				animation: {
				  count: 0,
				  enable: true,
				  speed: 3,
				  decay: 0,
				  sync: false,
				  destroy: "none",
				  startValue: "random",
				  minimumValue: 1
				}
			  },
			  stroke: {
				width: 0
			  },
			  zIndex: {
				random: {
				  enable: false,
				  minimumValue: 0
				},
				value: 0,
				opacityRate: 1,
				sizeRate: 1,
				velocityRate: 1
			  },
			  life: {
				count: 0,
				delay: {
				  random: {
					enable: false,
					minimumValue: 0
				  },
				  value: 0,
				  sync: false
				},
				duration: {
				  random: {
					enable: false,
					minimumValue: 0.0001
				  },
				  value: 0,
				  sync: false
				}
			  },
			  rotate: {
				random: {
				  enable: false,
				  minimumValue: 0
				},
				value: 0,
				animation: {
				  enable: false,
				  speed: 0,
				  decay: 0,
				  sync: false
				},
				direction: "clockwise",
				path: false
			  },
			  destroy: {
				bounds: {},
				mode: "none",
				split: {
				  count: 1,
				  factor: {
					random: {
					  enable: false,
					  minimumValue: 0
					},
					value: 3
				  },
				  rate: {
					random: {
					  enable: false,
					  minimumValue: 0
					},
					value: {
					  min: 4,
					  max: 9
					}
				  },
				  sizeOffset: true,
				  particles: {}
				}
			  },
			  roll: {
				darken: {
				  enable: false,
				  value: 0
				},
				enable: false,
				enlighten: {
				  enable: false,
				  value: 0
				},
				mode: "vertical",
				speed: 25
			  },
			  tilt: {
				random: {
				  enable: false,
				  minimumValue: 0
				},
				value: 0,
				animation: {
				  enable: false,
				  speed: 0,
				  decay: 0,
				  sync: false
				},
				direction: "clockwise",
				enable: false
			  },
			  twinkle: {
				lines: {
				  enable: false,
				  frequency: 0.05,
				  opacity: 1
				},
				particles: {
				  enable: false,
				  frequency: 0.05,
				  opacity: 1
				}
			  },
			  wobble: {
				distance: 5,
				enable: false,
				speed: {
				  angle: 50,
				  move: 10
				}
			  },
			  orbit: {
				animation: {
				  count: 0,
				  enable: false,
				  speed: 1,
				  decay: 0,
				  sync: false
				},
				enable: false,
				opacity: 1,
				rotation: {
				  random: {
					enable: false,
					minimumValue: 0
				  },
				  value: 45
				},
				width: 1
			  },
			  links: {
				blink: false,
				color: {
				  value: "random"
				},
				consent: false,
				distance: 100,
				enable: true,
				frequency: 1,
				opacity: 0.4,
				shadow: {
				  blur: 5,
				  color: {
					value: "#000"
				  },
				  enable: false
				},
				triangles: {
				  enable: false,
				  frequency: 1
				},
				width: 1,
				warp: false
			  },
			  repulse: {
				random: {
				  enable: false,
				  minimumValue: 0
				},
				value: 0,
				enabled: false,
				distance: 1,
				duration: 1,
				factor: 1,
				speed: 1
			  }
			},
			pauseOnBlur: true,
			pauseOnOutsideViewport: true,
			responsive: [],
			smooth: false,
			style: {},
			themes: [],
			zLayers: 100,
			emitters: []
		  }
		;
		
	   
		const particlesInit = useCallback(async (engine) => {
		  await loadFull(engine);
		}, []);

return (
	<div
	style={{
		height : "100vh",
        width: "100vw",
        justifyContent: 'space-between',
		
	}}
	>

	<Particles options={options} init={particlesInit} />
	<Alert severity="info" style={{opacity:0.7}}><h3 style={{color:"grey"}}>More notifications and certifications to be added as time goes on.</h3></Alert>
    <Card className="certificationcard1">
      <CardActionArea>
        <CardMedia
          component="img"
          image={certification1}
          alt="AWS Certification card"

        />
		
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            AWS SOLUTIONS ARCHITECT (COMING SOON)
          </Typography>
		  <Divider variant="left" color="white"/>
          <Typography variant="body2" color="text.secondary">
            I am currently preparing myself for the certification exam
			This card will be updated soon enough.
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>

	

	</div>
);
};

export default Certifications;
